export default __webpack_public_path__ + "static/media/envelop.cc9a7d48.svg";